import { _formatPlaylists, _formatPlaylist } from '../../helpers'

const learningPaths = state => _formatPlaylists(state.learningPaths)
const selectedLearningPath = state =>
  _formatPlaylist(state.selectedLearningPath)

export default {
  learningPaths,
  selectedLearningPath,
}
